export default __webpack_public_path__ + "missing-profile-picture.4c5643f056892cc3fe2f.png";